import React, { useState } from "react";
import { Button } from "@dhis2/ui";

export default function CommentInput({ value, onChange, placeholder, disabled }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div style={{ marginTop: "8px" }}>
      {expanded && (
        <textarea
          value={value || ""}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width: "100%",
            minHeight: "60px",
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ddd",
            background: disabled ? "#f2f2f2" : "#fff",
            resize: "vertical",
            fontSize: "14px",
          }}
        />
      )}
      <Button
        small
        primary
        onClick={() => setExpanded(!expanded)}
        disabled={disabled}
        style={{ marginTop: "4px" }}
      >
        {expanded ? "Hide Comment" : "Add Comment"}
      </Button>
    </div>
  );
}